import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	Inject,
	Input,
	Output,
	QueryList,
	ViewChildren,
} from '@angular/core';
import { CertDetail, CertHistoryDetail, PortalTypeEnum } from '@ats/api/cm';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';
import { CPCertLogicViewLocKeys, cpCertLogicViewLocs, SPCertLogicViewLocKeys, spCertLogicViewLocs } from './cm-cert-logic-view.locs';
import { LOC_INJECTOR, LocalizationProvider } from '@cm/core/localization';

@Component({
    selector: 'cm-cert-logic-view',
    templateUrl: './cm-cert-logic-view.component.html',
    styleUrls: ['./cm-cert-logic-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
	providers: [LocalizationProvider({...spCertLogicViewLocs, ...cpCertLogicViewLocs})]
})
export class CmCertLogicViewComponent {
	@Input() isHistoryVisible: boolean = false;
	@Input() cert: CertDetail;
	@Input() certHistoryDetail: CertHistoryDetail;
	@Input() showCurrentProgress: boolean = true;
	@Output() selectedHistoryId: EventEmitter<number> = new EventEmitter<number>();
	@ViewChildren('tab') tabs: QueryList<ElementRef>;
	readonly locFeature: PortalCoreFeature;
	selectedTrack: number = 0;
	isSp: boolean;

	constructor(private settings: CmSettingsService,
		@Inject(LOC_INJECTOR) public readonly locs: SPCertLogicViewLocKeys & CPCertLogicViewLocKeys
	) {
		this.locFeature = this.settings.portalCoreFeature;
		this.isSp = this.settings.portal === PortalTypeEnum.SponsorPortal;
	}

	emitHistoryId(id: number): void {
		this.selectedHistoryId.emit(id);
	}

	isItemSelected(itemId: number): boolean {
		return this.certHistoryDetail?.id === itemId;
	}

	tabKeyHandler(e: KeyboardEvent): void {
		const currentTab: number = this.tabs
			.toArray()
			.findIndex(tab => tab.nativeElement.id === document.activeElement.id);

		const formattedPositiveIndex = currentTab + 1 > this.tabs.length - 1 ? 0 : currentTab + 1;
		const formattedNegativeIndex = currentTab - 1 < 0 ? this.tabs.length - 1 : currentTab - 1;

		switch (e.key) {
			case 'ArrowUp':
				e.preventDefault();
				return this.tabs.toArray()[formattedNegativeIndex].nativeElement.focus();
			case 'ArrowDown':
				e.preventDefault();
				return this.tabs.toArray()[formattedPositiveIndex].nativeElement.focus();
			case 'ArrowLeft':
				e.preventDefault();
				return this.tabs.toArray()[formattedNegativeIndex].nativeElement.focus();
			case 'ArrowRight':
				e.preventDefault();
				return this.tabs.toArray()[formattedPositiveIndex].nativeElement.focus();
		}
	}
}
